export const apiBase = () =>
  import.meta.env.VITE_API_URL ? `${import.meta.env.VITE_API_URL}/api` : '/api'

export const aiProxyBase = () =>
  import.meta.env.VITE_AI_PROXY_URL
    ? `${import.meta.env.VITE_AI_PROXY_URL}/ai`
    : '/ai'

export const webSocketBase = () => {
  return import.meta.env.VITE_WS_URL
    ? `${import.meta.env.VITE_WS_URL}`
    : `wss://websockets.${window.location.host}`
}
